<template>
  <div>
    <!-- 地图选择弹窗 -->
    <el-dialog
      class="container"
      append-to-body
      :visible.sync="visible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      top="0vh"
      width="100%"
    >
      <div>
        <!-- 搜索框区域 -->
        <el-row>
          <el-col :span="8">
            <el-input
              v-model="keyword"
              placeholder="请输入关键字"
              @input="handleKeywordInput"
            />
            <!-- 搜索结果下拉面板 -->
            <div v-if="htmlshow" class="search-result-panel">
              <div
                v-for="item of searchResults"
                :key="item.name + item.address"
                class="search-result-item"
                @click="selectAddress(item)"
              >
                <span class="result-name">{{ item.name }}</span>
                <span class="result-address">{{ item.address }}</span>
              </div>
            </div>
          </el-col>
        </el-row>
        <!-- 天地图容器 -->
        <div id="map" class="map-container" />
      </div>
      <!-- 底部按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">确 定</el-button>
        <el-button @click="handleClose">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getzagldw } from '@/api/day_work'
import { filtersTree } from '@/utils'
/**
 * 默认坐标常量（西安市钟楼）
 * @constant {Object}
 * @property {string} lat - 纬度
 * @property {string} lon - 经度
 * @property {string} orgAddr - 默认地址名称
 */
const DEFAULT_COORDS = {
  lat: '34.259458',
  lon: '108.947001',
  orgAddr: '钟楼'
}
/**
 * 默认地图中心点坐标
 * @constant {number[]}
 */
const DEFAULT_CENTER = [108.947001, 34.259458]
/**
 * 默认地图缩放级别
 * @constant {number}
 */
const DEFAULT_ZOOM = 12
/**
 * 获取表单初始数据的工厂函数
 * @returns {Object} 表单初始数据对象
 * @property {string} lat - 纬度
 * @property {string} lon - 经度
 * @property {string} orgAddr - 地址
 * @property {string} province - 省份
 * @property {string} city - 城市
 * @property {string} district - 区县
 */
const getInitialFormData = () => ({
  lat: DEFAULT_COORDS.lat,
  lon: DEFAULT_COORDS.lon,
  orgAddr: DEFAULT_COORDS.orgAddr,
  province: '',
  city: '',
  district: ''
})
export default {
  name: 'Map',
  /**
   * 组件接收的属性
   * @property {Array} zagldwbm - 管辖单位编码数组
   * @property {Object} mapObj - 地图对象数据（用于回显）
   * @property {boolean} map - 控制弹窗显示状态
   */
  props: ['zagldwbm', 'mapObj', 'map'],
  data() {
    return {
      /** @type {string} 详细地址字符串 */
      addr: '',
      /** @type {boolean} 是否显示搜索结果面板 */
      htmlshow: false,
      /** @type {boolean} 弹窗可见状态 */
      visible: false,
      /** @type {Object} 天地图地图实例 */
      $map: null,
      /** @type {Object} 地理编码服务实例 */
      geocoder: null,
      /** @type {Object} 本地搜索服务实例 */
      localsearch: null,
      /** @type {Object} 地图标记实例 */
      marker: null,
      /** @type {string} 搜索关键字 */
      keyword: '',
      /** @type {Array} 搜索结果列表 */
      searchResults: [],
      /** @type {Object} 当前选中的地址对象 */
      address: null,
      /** @type {Object} 表单数据 */
      dataForm: getInitialFormData(),
      /** @type {Object} 搜索配置选项 */
      searchOption: {
        city: '全国',
        citylimit: true
      },
      /** @type {Object} 当前经纬度对象 */
      lnglat: null,
      /** @type {string} 当前选中单位名称 */
      hi_dwmc: '',
      /** @type {Array} 行政区划列表 */
      xzqh2List: []
    }
  },
  watch: {
    /**
     * 监听管辖单位编码变化
     * @param {Array} val - 新的单位编码数组
     */
    zagldwbm(val) {
      if (!val) return
      this.mapChange(val)
    }
  },
  computed: {
    /**
     * 管辖单位编码数据（计算属性包装）
     * @returns {Array}
     */
    zagldwbmData() {
      return this.zagldwbm
    },
    /**
     * 地图对象数据（计算属性包装）
     * @returns {Object}
     */
    mapObjData() {
      return this.mapObj
    }
  },
  async mounted() {
    // 获取行政区划列表数据
    this.xzqh2List = await getzagldw({})
    // 初始化地图状态
    this.mapChange(this.zagldwbmData, this.mapObjData)
    // 初始化天地图
    this.init()
  },
  methods: {
    /**
     * 更新地址数据
     * @param {Object} regeocode - 地理编码结果
     * @param {string} regeocode.formattedAddress - 格式化地址
     * @param {Object} regeocode.addressComponent - 地址组件
     * @param {string} regeocode.addressComponent.province - 省份
     * @param {string} regeocode.addressComponent.city - 城市
     * @param {string} regeocode.addressComponent.district - 区县
     * @param {number} lng - 经度
     * @param {number} lat - 纬度
     */
    updateAddressData(regeocode, lng, lat) {
      const { formattedAddress, addressComponent } = regeocode
      this.dataForm.orgAddr = formattedAddress
      this.dataForm.province = addressComponent.province
      this.dataForm.city = addressComponent.city
      this.dataForm.district = addressComponent.district
      this.dataForm.lat = lat?.toString() || ''
      this.dataForm.lon = lng?.toString() || ''
    },
    /**
     * 设置天地图标记
     * @param {number} lng - 经度
     * @param {number} lat - 纬度
     * @param {boolean} clearOverlays - 是否清除原有标记
     * @param {boolean} updateGeocoder - 是否更新地理编码
     * @description 统一处理天地图标记的创建、添加和事件绑定
     */
    setTianDiTuMarker(lng, lat, clearOverlays = true, updateGeocoder = true) {
      const T = window.T
      const lngLat = new T.LngLat(lng, lat)
      this.$map.centerAndZoom(lngLat, DEFAULT_ZOOM)
      if (clearOverlays) {
        this.$map.clearOverLays()
      }
      this.marker = new T.Marker(lngLat)
      this.$map.addOverLay(this.marker)
      this.marker.enableDragging()
      this.marker.addEventListener('dragend', e => this.handleMarkerDrag(e))
      this.lnglat = { lng, lat }
      if (updateGeocoder) {
        this.updateGeocoderLocation(lngLat)
      }
      return lngLat
    },
    /**
     * 选择搜索结果中的地址
     * @param {Object} data - 地址数据对象
     * @param {string} data.lonlat - 经纬度字符串，格式："lng,lat"
     * @param {string} data.name - 地点名称
     * @param {string} data.address - 详细地址
     * @description 点击搜索结果项时，在地图上定位该地址
     */
    selectAddress(data) {
      this.htmlshow = false
      const [lng, lat] = data.lonlat.split(',')
      this.setTianDiTuMarker(lng, lat)
    },
    /**
     * 处理标记拖拽事件
     * @param {Object} e - 拖拽事件对象
     * @param {Object} e.lnglat - 新的经纬度对象
     */
    handleMarkerDrag(e) {
      this.lnglat = e.lnglat
      this.updateGeocoderLocation(e.lnglat)
    },
    /**
     * 更新地理编码器位置
     * @param {Object} lngLat - 经纬度对象（天地图 LngLat 类型）
     * @description 根据经纬度获取地址信息并更新状态
     */
    updateGeocoderLocation(lngLat) {
      this.geocoder.getLocation(lngLat, data => {
        this.address = data.addressComponent
        this.addr = data.getAddress()
      })
    },
    /**
     * 处理关键字输入
     * @description 根据输入关键字触发地图搜索
     */
    handleKeywordInput() {
      if (!this.keyword) {
        this.htmlshow = false
        return
      }
      this.htmlshow = true
      this.localsearch.search(this.keyword, 7)
    },
    /**
     * 初始化天地图
     * @description 创建地图实例、标记、搜索服务
     */
    init() {
      const T = window.T
      const longitude = this.mapObj?.longitude || DEFAULT_CENTER[0]
      const latitude = this.mapObj?.latitude || DEFAULT_CENTER[1]
      this.geocoder = new T.Geocoder()
      this.$map = new T.Map('map')
      this.setTianDiTuMarker(longitude, latitude, false, false)
      this.localsearch = new T.LocalSearch(this.$map, {
        pageCapacity: 10,
        onSearchComplete: result => this.handleSearchResult(result)
      })
    },
    /**
     * 处理搜索结果
     * @param {Object} result - 搜索结果对象
     * @param {Array} result.pois - 兴趣点列表
     */
    handleSearchResult(result) {
      if (!this.keyword) return
      this.searchResults = result.pois || []
    },
    /**
     * 地图变化处理（根据管辖单位调整）
     * @param {Array} val - 管辖单位编码数组
     * @param {Object} mapObjData - 地图对象数据
     * @description 根据选中的行政区划调整地图搜索范围和初始位置
     */
    mapChange(val, mapObjData) {
      if (!this.$refs['mapSearch']) return
      const selCityName =
        filtersTree(this.xzqh2List, val[0])?.zagldwname?.replace(
          '公安局',
          ''
        ) || ''
      const selBureauName =
        filtersTree(this.xzqh2List, val[val.length - 1])?.zagldwname || ''
      this.hi_dwmc = selBureauName
      this.searchOption.city = selCityName
      if (mapObjData) {
        // 如果有已有地址数据，回填到搜索框
        this.$refs['mapSearch'].keyword = mapObjData.address
        this.dataForm.lon = mapObjData.longitude
        this.dataForm.lat = mapObjData.latitude
        this.dataForm.orgAddr = mapObjData.address
      } else {
        // 触发搜索按钮点击
        document.querySelector('.search-btn')?.click()
      }
      this.$refs['mapSearch'].keyword = ''
    },
    /**
     * 打开弹窗
     */
    open() {
      this.dataForm = getInitialFormData()
      this.visible = true
    },
    /**
     * 关闭弹窗
     * @description 关闭弹窗并通知父组件
     */
    handleClose() {
      this.visible = false
      this.$emit('update:map', false)
    },
    /**
     * 确认选择
     * @description 将选中的地址信息提交给父组件
     */
    confirm() {
      this.dataForm.orgAddr = this.addr
      this.dataForm.lon = this.lnglat?.lng || ''
      this.dataForm.lat = this.lnglat?.lat || ''
      this.dataForm.province = this.address?.province || ''
      this.dataForm.city = this.address?.city || ''
      this.dataForm.district = this.address?.county || ''
      this.dataForm.name = this.address?.poi || ''
      this.$emit(
        'updateLocation',
        this.dataForm.orgAddr,
        this.dataForm.lon,
        this.dataForm.lat,
        this.dataForm.province,
        this.dataForm.city,
        this.dataForm.district,
        this.dataForm.name,
        null,
        this.hi_dwmc
      )
      this.handleClose()
    }
  }
}
</script>
<style lang="scss" scoped>
.search-result-panel {
  width: 35%;
  height: 260px;
  background: #ffffff;
  position: absolute;
  top: 40px;
  z-index: 999;
  border: 1px solid #cccccc;
  padding: 10px;
  overflow-y: auto;
}
.search-result-item {
  cursor: pointer;
  color: #333333;
  padding: 5px 0;
  &:hover {
    background: #0056b3;
    color: #ffffff;
  }
}
.result-name {
  font-size: 18px;
  margin-right: 10px;
  font-weight: 500;
}
.result-address {
  font-size: 14px;
  color: #666666;
}
.map-container {
  width: 100%;
  height: 600px;
}
.title {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #f2f2f2;
  color: #333333;
  font-size: 14px;
  cursor: pointer;
}
.container {
  width: 80% !important;
  height: 90vh;
  margin: auto;
  overflow: hidden;
}
.search-box {
  z-index: 5;
  width: 100%;
  height: 38px;
  box-shadow: none;
  border: 1px solid #dcdfe6;
}
::v-deep .search-tips {
  z-index: 999 !important;
}
.search-box .el-input {
  position: relative;
  float: left;
  width: 100%;
  height: 100%;
  outline: none;
}
::v-deep .el-dialog__footer {
  position: relative;
}
.dialog-footer {
  position: absolute;
  left: 50%;
  top: -20px;
  transform: translateX(-50%);
  width: 160px;
}
.search-box .el-button {
  position: absolute;
  right: 0;
  top: 1px;
  width: 20%;
  background: #2d826e;
  border-radius: 0 7px 7px 0;
  border: none;
  color: #ffffff;
  outline: none;
}
.tip-box {
  text-align: center;
  width: 100%;
  position: absolute;
  top: 35px;
  padding: 10px 0;
  background-color: #ffffff;
  opacity: 0.8;
}
</style>
